export const SITE_URL = "https://abetglobal.com";

const DEFAULT_TITLE = "Forex, Crypto & CFD Broker | MT5 From $10";
const DEFAULT_DESCRIPTION =
  "Trade forex, crypto, metals, energies and indices with ABET on MetaTrader 5. Accounts from $10, leverage to 1:1000, spreads from 0.0 pips.";

export const SEO_PAGES = {
  "/": {
    title: DEFAULT_TITLE,
    description: DEFAULT_DESCRIPTION,
  },
  "/about": {
    title: "About ABET: Company, Registration & Contact",
    description:
      "Who ABET is, where it is registered, how to reach the team, and the trading services it offers across forex, CFDs and cryptocurrency.",
  },
  "/faqs": {
    title: "ABET FAQs: Deposits, Leverage, Accounts & MT5",
    description:
      "ABET FAQs: $10 minimum deposit, MetaTrader 5, account types, spreads, margin, leverage and trading hours, for Micro through Raw Spread.",
  },
  "/micro": {
    title: "ABET Micro Account: $10 Deposit, 1:1000 Leverage",
    description:
      "The ABET Micro account: $10 minimum deposit, 1,000-unit lots, leverage to 1:1000, no commission, negative balance protection and swap-free option.",
  },
  "/standard": {
    title: "ABET Standard Account: 0.5 Pip Spreads, 100k Lots",
    description:
      "The ABET Standard account: $10 minimum deposit, spreads from 0.5 pips, no commission, leverage to 1:1000 and 100,000-unit standard lots.",
  },
  "/raw-spread": {
    title: "ABET Raw Spread Account: 0.0 Pip Spreads, 1:500",
    description:
      "The ABET Raw Spread account: spreads from 0.0 pips on majors, leverage to 1:500, $1,000 minimum deposit, built for scalpers and high-volume traders.",
  },
  "/prime": {
    title: "ABET Prime Account: Bonus Facility, 1:1000 Leverage",
    description:
      "The ABET Prime account: $10 minimum deposit, leverage to 1:1000, no commission, and the only ABET account with a bonus facility.",
  },
  "/forex": {
    title: "Forex Trading with ABET: 50+ Pairs, 1:1000 Leverage",
    description:
      "Trade over 50 currency pairs with ABET: majors, crosses and exotics, tight floating spreads, leverage to 1:1000 and 24/5 market access on MT5.",
  },
  "/indices": {
    title: "Trade Stock Indices: US500, US100, GER40 | ABET",
    description:
      "Trade global stock indices with ABET, including US500, US100, UK100, GER40 and JP225, with leverage to 1:500 and no hidden fees.",
  },
  "/energies": {
    title: "Oil & Gas Trading with ABET | Margin From $10",
    description:
      "Trade crude oil and natural gas CFDs with ABET: margin from $10, no overnight financing charges on oil, and long or short in both directions.",
  },
  "/metals": {
    title: "Gold & Silver Trading with ABET | No Swap Fees",
    description:
      "Trade gold, silver, platinum and palladium with ABET: leverage to 1:1000, no requotes, no swap fees and tight floating spreads on MT5.",
  },
  "/cryptocurrency": {
    title: "Crypto CFD Trading with ABET | 24/7, 1:500",
    description:
      "Trade Bitcoin, Ethereum and other crypto CFDs with ABET: available 24/7, leverage to 1:1000, tight spreads and no commission.",
  },
  "/spreads": {
    title: "ABET Spreads: Starting Rates by Account Type",
    description:
      "ABET's floating spreads by account: Raw Spread, Standard, Micro and Prime, aggregated from multiple liquidity providers and updated three times a second.",
  },
  "/margin-leverage": {
    title: "ABET Margin & Leverage: Tiers and Stop-Out Levels",
    description:
      "How margin and leverage work at ABET: equity-based leverage tiers, dynamic crypto margin with worked examples, margin call and stop-out levels.",
  },
  "/execution-policy": {
    title: "ABET Order Execution Policy | Market Execution",
    description:
      "ABET's order execution policy: market execution, order types, fill handling and the trading conditions that apply to every order.",
  },
  "/meta-trader-5": {
    title: "Download MetaTrader 5 for PC, Mac & Mobile | ABET",
    description:
      "Download MetaTrader 5 from ABET for Windows, Mac, WebTrader, iPhone, iPad and Android. Expert Advisors, 21 timeframes and 38 indicators.",
  },
  "/blogs": {
    title: "Forex & Crypto Market News and Analysis | ABET",
    description:
      "Market analysis, trading education and platform guides from ABET, covering forex, gold, oil, indices and cryptocurrency.",
  },
  "/forex-dictionary": {
    title: "Forex Dictionary: Trading Terms A–Z | ABET",
    description:
      "An A to Z dictionary of forex and CFD trading terms, from arbitrage and ATR to spreads, swaps and stop-outs, explained plainly by ABET.",
  },
  "/contact": {
    title: "Contact ABET: Support, Phone, Email & WhatsApp",
    description:
      "Contact ABET support by email, phone or WhatsApp. Support runs 24/5 Monday to Friday, plus 9:00 to 18:00 GMT on Saturday and Sunday.",
  },
  "/promotions": {
    title: "ABET Promotions, Bonuses & Special Offers",
    description:
      "Current ABET trading promotions and bonus offers, including deposit credit and the 30-day free demo account.",
  },
  "/risk": {
    title: "Risk Disclosure: Trading CFDs with Leverage | ABET",
    description:
      "ABET's risk disclosure for leveraged forex and CFD trading, covering the risk of losing invested funds and how leverage magnifies losses.",
  },
  "/legal-documents": {
    title: "ABET Legal Documents & Client Agreement",
    description:
      "ABET's Client Agreement, Risk Disclosure, Execution Policy and complaint handling documents, available to download.",
  },
  "/privacy-policy": {
    title: "ABET Privacy Policy: How Your Data Is Used",
    description:
      "How ABET collects, uses, stores and discloses personal data, and the rights clients have over their information.",
  },
};

export function normalizePath(pathname = "/") {
  if (!pathname || pathname === "/") return "/";
  const clean = pathname.replace(/\/+$/, "");
  return clean || "/";
}

export function canonicalUrl(pathname = "/") {
  const path = normalizePath(pathname);
  return path === "/" ? `${SITE_URL}/` : `${SITE_URL}${path}`;
}

export function getSeoForPath(pathname = "/") {
  const path = normalizePath(pathname);
  const page = SEO_PAGES[path];
  return {
    title: page?.title || DEFAULT_TITLE,
    description: page?.description || DEFAULT_DESCRIPTION,
    canonical: canonicalUrl(path),
  };
}
